define('areas/navigationmanager/commands/creategroupcommand',["require", "exports"], function (require, exports) {
    "use strict";
    var CreateGroupCommand = (function () {
        function CreateGroupCommand(process) {
            this._createGroup = process;
        }
        CreateGroupCommand.prototype.execute = function (symbol) {
            this._createGroup.process(symbol);
        };
        return CreateGroupCommand;
    }());
    return CreateGroupCommand;
});

